import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    paddingBottom: "24px",
    paddingTop: "10px",
  },
  media: {
    height: "68px",
    width: "81px",
    borderRadius: "12px",
  },

  courseContainer: {
    paddingLeft: "10px",
    paddingBottom: "25px",
  },

  courseName: {
    color: "#000000",
    fontWeight: 700,
    fontSize: "11px",
    lineHeight: "15px",
    paddingTop: "5px",
  },
  id: {
    fontSize: "10px",
    lineHeight: "10px",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
    fontWeight: 500,
  },

  iconBtn: {
    height: "16px",
    width: "16px",
    borderRadius: "2px",
    padding: "12px 10px 12px 10px",
  },
  iconClass: {
    height: "16px !important",
    width: "16px !important",
  },
  price: {
    fontWeight: 500,
    fontSize: "11px",
    lineHeight: "10px",
    letterSpacing: "0.75px",
    textAlign: "right",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  },
  dialogAction: {
    background: "#F4F6F8",
    paddingTop: "20px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },
  basketActionWrapper: {
    width: "100%",
  },
  totalPriceContainer: {
    paddingBottom: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: 0,
    paddingLeft: 0,
  },
  actionButtonsContainer: {
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: 0,
    paddingLeft: 0,
  },
  vatContainerLabel: {
    fontSize: "10px",
    lineHeight: "10px",
    letterSpacing: "0.75px",
    paddingBottom: "20px",
    marginLeft: 0,
    paddingLeft: 0,
  },
  actionContainer: {
    diplay: "flex",
    justifyContent: "flex-end",
  },
  quantity: {
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "12px",
    textAlign: "left",
    padding: "2px 0px 2px 4px",
  },
  btnClass: {
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "20px",
    color: "#FFFFFF",
    backgroundColor: "#1E49E2",
    textTransform: "none",
    borderRadius: "100px",
    "&:hover": {
      backgroundColor: "#1E49E2",
      outline: "2px solid #000000",
    },
    "&.Mui-disabled": {
      color: "#525252",
      backgroundColor: "#E6E6E6",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #000000",
    },
  },
  proceedCheckout: {
    paddingLeft: "0px",
  },
  arrowForward: {
    height: "16px",
    width: "16px",
  },

  dialogTitle: {
    "&.MuiTypography-h6": {
      fontWeight: 700,
      fontSize: "13px !important",
      lineHeight: "10px !important",
      textTransform: "uppercase",
    },

    marginTop: "-50px",
    borderBottom: "1px inset",
  },
  dialogTitleMobile: {
    fontWeight: 700,
    fontSize: "10px !important",
    lineHeight: "10px !important",
    textTransform: "uppercase",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "1px inset",
  },

  continueShopping: {
    fontWeight: 400,
    color: "#000000",
    fontSize: "12px !important",
    lineHeight: "20px !important",
    letterSpacing: "-0.1px !important",
    paddingLeft: "0px !important",
    textTransform: "none",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "underline",
      outline: "2px solid #000000",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #000000",
    },
  },

  totallabel: {
    fontSize: "10px",
    lineHeight: "10px",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
  },
  total: {
    fontWeight: 700,
    fontSize: "12px",
    lineHeight: "10px",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
  },
  root: {
    "& .MuiPaper-root": {
      borderRadius: "12px !important",
      "@media (min-width:1200px)": {
        top: "8%",
        left: "60%",
        position: "absolute",
      },
    },
  },
  quantityPriceContainer: {
    paddingTop: "10px",
  },
  content: {
    maxHeight: "280px",
    overflow: "scroll",
  },
}));
